import * as React from "react";
import styled from "styled-components";

/** PackageComparisonExpandableElementRow */
interface PackageComparisonExpandableElementRowProps {
  elementName: string
  elementIsFree: boolean
}

const PackageComparisonExpandableElementRow = (props: PackageComparisonExpandableElementRowProps) => {
  const {elementName,elementIsFree} = props;
  return (
    <PackageComparisonExpandableElementRowWrapper>
      <FeatureNameWrapper>{elementName}</FeatureNameWrapper>
      <FeatureIconWrapper>
        <i className={elementIsFree ? "fa fa-check fa-lg" : "fa fa-times fa-lg"}/>
      </FeatureIconWrapper>
      <FeatureIconWrapper>
        <i className="fa fa-check fa-lg"/>
      </FeatureIconWrapper>
    </PackageComparisonExpandableElementRowWrapper>
  )
};

/** STYLES => PackageComparisonExpandableElementRow */

const PackageComparisonExpandableElementRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 55px;
  padding-right: 2px;
`;

const FeatureNameWrapper = styled.div`
  flex-basis: 40%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #4d4d4d;
`;

const FeatureIconWrapper = styled.div`
  flex-basis: 30%;
  max-width: 300px;
  box-shadow: 0 9px 0px 0px #fff, 0 -9px 0px 0px #fff, 12px 0 22px -4px rgba(0, 0, 0, 0.12), -12px 0 22px -4px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  i.fa.fa-check {
    color: green;
  }
  i.fa.fa-times {
    color: red;
  }
`;

/** PackageComparisonExpandableElementLastRow */
interface PackageComparisonExpandableElementLastRowProps {}

const PackageComparisonExpandableElementLastRow = (props: PackageComparisonExpandableElementLastRowProps) => {
  return (
    <PackageComparisonExpandableElementLastRowWrapper>
      <FeatureNameLastRowWrapper/>
      <FeatureIconLastRowWrapper/>
      <FeatureIconLastRowWrapper/>
    </PackageComparisonExpandableElementLastRowWrapper>
  )
};

/** STYLES => PackageComparisonExpandableElementLastRow */

const PackageComparisonExpandableElementLastRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 2px;
`;

const FeatureNameLastRowWrapper = styled.div`
  flex-basis: 40%;
`;

const FeatureIconLastRowWrapper = styled.div`
  flex-basis: 30%;
  max-width: 300px;
  // box-shadow: 0 4px 2px 2px rgba(0, 0, 0, 0.12);
  height: 1px;
  border-bottom: 3px solid rgba(0, 0, 0, 0.12);
`;

/** PackageComparisonExpandableElement */
interface PackageComparisonExpandableElementProps {
  appModuleName: string
  appModuleElements: {
    elementName: string
    elementIsFree: boolean
  }[]
}

interface PackageComparisonExpandableElementState {
  elementIsOpen: boolean
}

class PackageComparisonExpandableElement extends React.Component<PackageComparisonExpandableElementProps,PackageComparisonExpandableElementState> {

  constructor(props: PackageComparisonExpandableElementProps) {
    super(props);
    this.state = {
      elementIsOpen: false
    };
    this.toggleElement = this.toggleElement.bind(this);
  }

  toggleElement() {
    const {elementIsOpen} = this.state;
    this.setState({elementIsOpen: !elementIsOpen})
  }

  render() {
    const {appModuleName,appModuleElements} = this.props;
    const {elementIsOpen} = this.state;
    return (
      <PackageComparisonExpandableElementWrapper className="panel panel-default" onClick={this.toggleElement}>
        <div className="panel-heading">
          <h3 className="panel-title">
            <a className={elementIsOpen ? '' : 'collapsed'} aria-expanded={elementIsOpen}>{appModuleName}</a>
          </h3>
        </div>
        <div className={elementIsOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse'}>
          <div>
            {appModuleElements.map(((element: any, index: number) =>
              <PackageComparisonExpandableElementRow
                key={index}
                {...element}
              />
            ))}
          </div>
          <PackageComparisonExpandableElementLastRow/>
        </div>
      </PackageComparisonExpandableElementWrapper>
    )
  }

}

/** STYLES */

const PackageComparisonExpandableElementWrapper = styled.div`
  h3 {
    line-height: 1.1rem;  
  }
`;

export default PackageComparisonExpandableElement


// WEBPACK FOOTER //
// ./src/layouts/package-comparison-block/package-comparison-expandable-element.tsx